export default __webpack_public_path__ + "static/media/point.300bf855.svg";